import axios from 'axios';

/**
 * APIエラーや一般のエラーから詳細なエラーメッセージを抽出します。
 * AxiosErrorの場合はサーバーからのレスポンスボディ（data.error や data.message）を優先して返します。
 */
export function getErrorMessage(error: unknown, fallbackMessage = 'エラーが発生しました'): string {
  if (axios.isAxiosError(error)) {
    if (error.response?.data) {
      const data = error.response.data as any;
      if (typeof data.error === 'string' && data.error.trim()) {
        return data.error;
      }
      if (typeof data.message === 'string' && data.message.trim()) {
        return data.message;
      }
    }
    return error.message || fallbackMessage;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  return fallbackMessage;
}
